import React, { Component } from 'react';
import { Card, message } from 'antd';
import Process from '@comm/workflow/Process';
import { queryPurchaseWorkflow, querySavePurchase } from '@api/administrative/purchase';
import FormBase from './FormBase';

class Page extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataInfo: {},
      isSubmitting: false,
      instance: {
        activities: [],
        currentActivity: {},
      },
    };
  }

  componentDidMount() {
    this.purchaseWorkflow();
  }

  /**
   * 提交采购
   */
  handSubmit = item => {
    this.savePurchase(item);
  };

  purchaseWorkflow = params => {
    const { instance } = this.state;
    queryPurchaseWorkflow(params).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          instance: {
            ...instance,
            activities: res.data,
          },
        });
      }
    });
  };

  /**
   * 保存
   */
  savePurchase = item => {
    this.setState({
      isSubmitting: true,
    });
    querySavePurchase(item).then(res => {
      this.setState({
        isSubmitting: false,
      });
      if (res.statusCode === 200) {
        message.success(res.message);
        this.props.router.go(-1);
      } else {
        message.error(res.message);
      }
    });
  };

  render() {
    const { dataInfo, isSubmitting, instance } = this.state;
    return (
      <div>
        <FormBase data={dataInfo} handSubmit={this.handSubmit} isSubmitting={isSubmitting} />
        <Card>
          <Process instance={instance} />
        </Card>
      </div>
    );
  }
}

export default Page;



// WEBPACK FOOTER //
// ./src/components/administrative/purchase/PageAdd.js